import React, {useState, useEffect} from 'react';
import {
  Grid,
  Avatar,
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
  Checkbox,
} from '@material-ui/core';
import moment from 'moment';
import EmailIcon from '@material-ui/icons/Email';
import {Link} from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import {GetData} from '../utils/Storage';
import {formatDate} from '../utils/formatDate';

const UserBusinessItem = ({user, isSelected, toggleEmail}) => {
  const [loading, setLoading] = useState(false);
  const business = GetData('business');

  const subscriptionType = premium => {
    switch (premium) {
      case 'F':
        return 'Free';
      case 'M':
        return 'Mensal';
      case 'Y':
        return 'Anual';
      case 'N':
        return 'New';
      case 'G':
        return 'Gift';
      case 'S':
        return 'Parceiro Especial';
      default:
        return premium;
    }
  };

  const initialLetter = user.name || '';

  return (
    <React.Fragment>
      <ListItem alignItems="flex-start">
        <Checkbox
          checked={isSelected}
          onChange={() => toggleEmail(user.email)}
        />

        <ListItemAvatar>
          <Avatar
            src={user.thumbnailURL}
            alt="Remy Sharp"
            style={{textTransform: 'uppercase'}}>
            {user && initialLetter[0]}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={user.name}
          secondary={
            <Grid container>
              <Grid item xs={2}>
                <ListItemIcon>
                  <EmailIcon />
                  <Typography
                    style={{marginLeft: 8, wordBreak: 'break-word'}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    {user.email}
                  </Typography>
                </ListItemIcon>
              </Grid>

              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Departamento: {user?.departament || '-'}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Telefone: {user?.phone || '-'}
                  </Typography>
                </ListItemIcon>
              </Grid>

              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Plano: {user.type_premium_b2b || '-'}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Plano anterior: -
                  </Typography>
                </ListItemIcon>
              </Grid>

              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Data cadastro:{' '}
                    {moment.utc(user.createdAt).format('DD/MM/YYYY') || '-'}
                  </Typography>
                </ListItemIcon>
              </Grid>

              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Onboarding: {!!user.onboarding_date ? 'Sim' : 'Não'}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Usuário ativo nos últimos 30 dias:{' '}
                    {user?.access_logs.length > 0 ? 'Sim' : 'Não'}
                  </Typography>
                </ListItemIcon>
              </Grid>

              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Status:{' '}
                    {user?.is_active
                      ? 'Ativo'
                      : `Excluído em ${formatDate(user.delete_date)}`}
                  </Typography>
                </ListItemIcon>
              </Grid>

              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Empresa: {user?.business?.corporateName || '-'}
                  </Typography>
                </ListItemIcon>
              </Grid>
            </Grid>
          }
        />
        {business.adminMaster && (
          <ListItemSecondaryAction>
            <IconButton
              component={Link}
              to={`/usuarios-empresa/edit/${user.id}`}
              edge="end">
              <EditIcon />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
      <Divider />
    </React.Fragment>
  );
};
export default UserBusinessItem;
